import { createSelector } from 'reselect'
import { detectLanguage } from 'helpers/functions'

const getStorefrontOwnerData = state => state.storefront.owner
const getUserData = state => state.user
const getMyAccountData = state => state.myAccount

const defaultUserData = {
	userName: '',
	schoolName: '',
	accountDate: '',
}
const defaultMyAccountData = {
	userGrades: [],
	userSubjects: [],
}

const storefront_owner_header_selector = createSelector(
	[ getStorefrontOwnerData, getUserData, getMyAccountData ],
	(ownerState, userState, myAccountState) => {

		let userStorefrontData = {}
		if (userState.data && userState.data.account) {
			userStorefrontData.userName = `${userState.data.firstName} ${userState.data.lastName}` || ''
			userStorefrontData.schoolName = userState.data.account.schoolName || ''

			const locale = detectLanguage()
			const accountDate = new Date(parseInt(userState.data.created)*1000)
			const accountMonth = accountDate.toLocaleString(locale, { month: 'long' })
			const accountYear = accountDate.getFullYear()
			userStorefrontData.accountDate = accountMonth + ' ' + accountYear
		} else {
			userStorefrontData = defaultUserData
		}

		userStorefrontData.followersCount = ' '
		if (ownerState.data && ownerState.data.owner_follow_data) {
			userStorefrontData.followersCount = ownerState.data.owner_follow_data.data.ownerFollowersCount
		}

		let myAccountData = {}
		if (myAccountState.data) {
			const grades = myAccountState.data.grades || []
			const gradeIds = myAccountState.data.gradeIds || []
			const subjects = myAccountState.data.subjects || []
			const subjectIds = myAccountState.data.subjectIds || []

			myAccountData.userGrades = grades.filter(grade => gradeIds.includes(grade.id)).map(grade => grade.value)
			myAccountData.userSubjects = subjects.filter(subject => subjectIds.includes(subject.id)).map(subject => subject.value)
		} else {
			myAccountData = defaultMyAccountData
		}

		const bioData = {}
		bioData.bio = ownerState.data.bio
		bioData.bioToSubmit = ownerState.data.bio_to_submit
		bioData.showBioForm = ownerState.data.edit_bio


		const lessonsCount = ownerState.lessons.count ? ownerState.lessons.count : ' '

		return {
			userData: userStorefrontData,
			accountData: myAccountData,
			bioData,
			count: lessonsCount,
			ownerId: ownerState.data.ownerId,
			downloadsCount: ownerState.data.downloads,
		}
	}
)

export default storefront_owner_header_selector
